import { Reducer } from 'redux';
import { IAppState } from '../../../app-state';
import {
  ActionTypes,
  Status,
  FeatureFlags,
  IFeatureFlagsAction,
} from './constants';

export interface IFeatureFlagsState {
  status: Status;
  featureFlags: FeatureFlags;
}

export const initialState: IFeatureFlagsState = {
  status: Status.None,
  featureFlags: {},
};

// Reducer
const featureFlagsReducer: Reducer = (
  state = initialState,
  action: IFeatureFlagsAction,
): IFeatureFlagsState => {
  switch (action.type) {
    case ActionTypes.FEATURE_FLAGS_INIT:
      return {
        ...state,
        status: Status.Loading,
      };
    case ActionTypes.FEATURE_FLAGS_SET:
      return {
        featureFlags: {
          ...state.featureFlags,
          ...action.payload,
        },
        status: Status.Successful,
      };
    case ActionTypes.FEATURE_FLAGS_RETRIEVAL_FAILED:
      return {
        ...state,
        status: Status.Failed,
      };
    default:
      return state;
  }
};

// Selectors
export function getFeatureFlag(state: IAppState, featureFlagName: string): boolean {
  return state.featureFlagsState?.featureFlags?.[featureFlagName] || false;
}

export function getFeatureFlagsRetrievalStatus(state: IAppState): Status {
  return state.featureFlagsState?.status || Status.None;
}

export default featureFlagsReducer;
